import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { IConfigBasicData } from '@shared/model/basic-data';
import { IOption } from '@shared';

const basicDataActions = createActionGroup({
  source: 'Basic Data',
  events: {
    'Get Country Regions': props<{ countryId: number }>(),
    'Get Country Regions Success': props<{ regions: IOption[] }>(),
    'Get Country Regions Failure': emptyProps(),
  },
});

export const { getCountryRegions, getCountryRegionsSuccess, getCountryRegionsFailure } = basicDataActions;

export enum ConfigActionTypes {
  GET_CONFIG = '[Basic Data] Get Config',
  GET_CONFIG_SUCCESS = '[Basic Data] Get Config Success',
  GET_CONFIG_FAILURE = '[Basic Data] Get Config Failure',

  GET_SEGMENTS = '[Basic Data] Get Segments',
  GET_SEGMENTS_SUCCESS = '[Basic Data] Get Segments Success',
  GET_SEGMENTS_FAILURE = '[Basic Data] Get Segments Failure',

  GET_CUREENCIES = '[Basic Data] Get Currencies',
  GET_CUREENCIES_SUCCESS = '[Basic Data] Get Currencies Success',
  GET_CUREENCIES_FAILURE = '[Basic Data] Get Currencies Failure',

  GET_COUNTRIES = '[Basic Data] Get Countries',
  GET_COUNTRIES_SUCCESS = '[Basic Data] Get Countries Success',
  GET_COUNTRIES_FAILURE = '[Basic Data] Get Countries Failure',

  GET_INDUSTRIES = '[Basic Data] Get Industries',
  GET_INDUSTRIES_SUCCESS = '[Basic Data] Get Industries Success',
  GET_INDUSTRIES_FAILURE = '[Basic Data] Get Industries Failure',
}

export const getConfig = createAction(ConfigActionTypes.GET_CONFIG);

export const getConfigSuccess = createAction(ConfigActionTypes.GET_CONFIG_SUCCESS, props<{ config: IConfigBasicData }>());

export const getConfigFailure = createAction(ConfigActionTypes.GET_CONFIG_FAILURE);

export const getSegments = createAction(ConfigActionTypes.GET_SEGMENTS, props<{ industry: number }>());

export const getSegmentsSuccess = createAction(
  ConfigActionTypes.GET_SEGMENTS_SUCCESS,
  props<{ segments: IOption[] }>(),
);

export const getSegmentsFailure = createAction(ConfigActionTypes.GET_SEGMENTS_FAILURE);

export const getCurrencies = createAction(ConfigActionTypes.GET_CUREENCIES);

export const getCurrenciesSuccess = createAction(
  ConfigActionTypes.GET_CUREENCIES_SUCCESS,
  props<{ currencies: IOption[] }>(),
);

export const getCurrenciesFailure = createAction(ConfigActionTypes.GET_CUREENCIES_FAILURE);

export const getCountries = createAction(ConfigActionTypes.GET_COUNTRIES);

export const getCountriesSuccess = createAction(
  ConfigActionTypes.GET_COUNTRIES_SUCCESS,
  props<{ countries: IOption[] }>(),
);

export const getCountriesFailure = createAction(ConfigActionTypes.GET_COUNTRIES_FAILURE);

export const getIndustries = createAction(ConfigActionTypes.GET_INDUSTRIES);

export const getIndustriesSuccess = createAction(
  ConfigActionTypes.GET_INDUSTRIES_SUCCESS,
  props<{ industries: IOption[] }>(),
);

export const getIndustriesFailure = createAction(ConfigActionTypes.GET_INDUSTRIES_FAILURE);
